<template>
  <section class="contest-step3">
    <p class="notice" v-if="!hasSubmit">
      {{ $t("global.注") }}：{{
        $t("global.参赛作品不可在参赛期间自行删除")
      }}。{{ $t("global.如需修改参赛信息") }}，{{
        $t("global.可在个人中心")
      }}-{{ $t("global.我的竞赛下点击") }}“{{ $t("global.编辑") }}”{{
        $t("global.进行修改")
      }}
    </p>
    <el-form
      v-if="!hasSubmit"
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      class="ruleForm"
    >
      <!-- <el-form-item :label="$t('global.参赛类别')" prop="categoryId" v-if="categoryList.length >0">
        <el-select
          v-model="ruleForm.categoryId"
          style="width:200px;"
          :placeholder="$t('global.请选择参赛类别')"
        >
          <el-option
            :label="item.title"
            :value="item.categoryId"
            v-for="(item,i) in categoryList"
            :key="i"
          ></el-option>
        </el-select>
      </el-form-item>-->
      <div v-if="matchId == 1032">
        <div
          class="contain editTitles containtitle"
        >
          <div class="left">
            <p class="font">{{ $t('video.首选投稿分类') }}</p>
            <span>{{ $t('video.单选，必填') }}</span>
          </div>
          <div class="right">
            <div class="moretitle">
              <span
                v-for="(item, index) in categoryList"
                :key="index"
                @click="changeIndustryIds(item.categoryId)"
                :class="{ active: isSelectOne(item.categoryId, industryIds),active1: isSelectOne2(item.categoryId, otherCategoryIds) }"
                >{{ item.title }}</span
              >
            </div>
          </div>
          <div class="left">
            <p class="font1">{{ $t('video.次选投稿分类') }}</p>
            <span>{{ $t('video.单选，选填') }}</span>
          </div>
          <div class="right">
            <div class="moretitle">
              <span
                v-for="(item, index) in categoryList"
                :key="index"
                @click="changeIndustryIds1(item.categoryId)"
                :class="{ active: isSelectOne1(item.categoryId, otherCategoryIds),active1: isSelectOne2(item.categoryId, industryIds) }"
                >{{ item.title }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div
          class="contain editTitles containtitle"
          v-if="categoryList && categoryList.length && matchId !== 1031"
        >
          <div class="left">
            <p class="font">{{ $t("global.参赛类别") }}</p>
            <span>{{ $t("video.最多选择x个",{num: num}) }}</span>
          </div>
          <div class="right">
            <div class="moretitle">
              <span
                v-for="(item, index) in categoryList"
                :key="index"
                @click="changeIndustryIds(item.categoryId)"
                :class="{ active: isSelectOne(item.categoryId, industryIds) }"
                >{{ item.title }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <el-form-item :label="$t('global.参赛方式')" prop="entryMode">
        <el-radio-group v-model="ruleForm.entryMode">
          <el-radio :label="1">{{ $t("global.个人") }}</el-radio>
          <el-radio :label="2">{{ $t("global.团队") }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        :label="$t('global.团队名称')"
        prop="teamName"
        v-if="ruleForm.entryMode === 2"
      >
        <el-input v-model="ruleForm.teamName"></el-input>
      </el-form-item>
      <div v-if="matchId == '1030'">
        <el-form-item :label="$t('works.预估作品落地成本')" prop="estimateCost">
          <el-radio-group v-model="ruleForm.estimateCost">
            <el-radio :label="1">{{ $t("works.5万以下") }}</el-radio>
            <el-radio :label="2">{{ $t("works.5-10万") }}</el-radio>
            <el-radio :label="3">{{ $t("works.10-30万") }}</el-radio>
            <el-radio :label="4">{{ $t("works.30-50万") }}</el-radio>
            <el-radio :label="5">{{ $t("works.50万以上") }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <div v-if="matchId == '1005'">
        <el-form-item class="bottom5">
          <p class="notice2">
            {{
              $t(
                "global.以下设计项目信息默认在成功设计大赛官网公开展示，如不希望公开，可在下方选择不公开"
              )
            }}
          </p>
        </el-form-item>
        <el-form-item :label="$t('global.作品价值')" prop="userValue">
          <p class="intro">
            {{ $t("global.这个作品为用户提供了什么价值") }}？{{
              $t("global.参考")
            }}：
            <br />
            {{
              $t(
                "global.这个作品着重在···(功能创新、情感连接、审美、用户体验···)进行了深入地思考，并做了···的尝试/改进/改革"
              )
            }}
          </p>
          <el-input
            type="textarea"
            v-model="ruleForm.userValue"
            :placeholder="$t('global.请填写中文版')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="enUserValue" class="bottom5">
          <el-input
            type="textarea"
            v-model="ruleForm.enUserValue"
            :placeholder="$t('global.请填写英文版')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="userValueIsOpen">
          <el-checkbox-group v-model="ruleForm.userValueIsOpen">
            <el-checkbox
              :label="$t('global.不公开')"
              name="userValueIsOpen"
            ></el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item :label="$t('global.商业表现')" prop="businessPerformance">
          <p class="intro">
            {{ $t("global.这个作品在商业上有什么表现") }}？{{
              $t("global.参考")
            }}：
            <br />
            {{
              $t(
                "global.该作品在发布后的···时间内，在（市场销量/占有率，传播价值，品牌知名度···）方面获得了···的成绩"
              )
            }}
          </p>
          <el-input
            type="textarea"
            v-model="ruleForm.businessPerformance"
            :placeholder="$t('global.请填写中文版')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="enBusinessPerformance" class="bottom5">
          <el-input
            type="textarea"
            v-model="ruleForm.enBusinessPerformance"
            :placeholder="$t('global.请填写英文版')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="businessPerformanceIsOpen">
          <el-checkbox-group v-model="ruleForm.businessPerformanceIsOpen">
            <el-checkbox
              :label="$t('global.不公开')"
              name="businessPerformanceIsOpen"
            ></el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item :label="$t('global.社会影响')" prop="socialImpact">
          <p class="intro">
            {{ $t("global.这个作品为社会带来了什么价值") }}？{{
              $t("global.参考")
            }}：
            <br />
            {{
              $t(
                "global.该作品改变了···的现状/推进了行业向···方向发展/对文化发展起到了···作用/在可持续发展方面发挥了···作用"
              )
            }}
          </p>
          <el-input
            type="textarea"
            v-model="ruleForm.socialImpact"
            :placeholder="$t('global.请填写中文版')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="enSocialImpact" class="bottom5">
          <el-input
            type="textarea"
            v-model="ruleForm.enSocialImpact"
            :placeholder="$t('global.请填写英文版')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="socialImpactIsOpen">
          <el-checkbox-group v-model="ruleForm.socialImpactIsOpen">
            <el-checkbox
              :label="$t('global.不公开')"
              name="socialImpactIsOpen"
            ></el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item :label="$t('global.团队组织')" prop="team">
          <p class="intro">
            {{ $t("global.有哪些人参与了这个作品") }}，{{
              $t("global.他们在过程中的角色是")
            }}？{{ $t("global.参考") }}：
            <br />
            {{ $t("global.这个作品一共有···位全职成员参与") }}，
            {{
              $t(
                "global.他们分别负责···（设计、结构、策划、市场···）；公司内部/客户方负责···的部门在项 目的···阶段介入给予···的帮助；外部的···（专家、用户、KOL）也在作品的···阶段 介入，担任了···角色"
              )
            }}
          </p>
          <el-input
            type="textarea"
            v-model="ruleForm.team"
            :placeholder="$t('global.请填写中文版')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="enTeam" class="bottom5">
          <el-input
            type="textarea"
            v-model="ruleForm.enTeam"
            :placeholder="$t('global.请填写英文版')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="teamIsOpen">
          <el-checkbox-group v-model="ruleForm.teamIsOpen">
            <el-checkbox
              :label="$t('global.不公开')"
              name="teamIsOpen"
            ></el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item :label="$t('global.流程方法')" prop="processMethod">
          <p class="intro">
            {{ $t("global.在作品流程中有哪些创新点") }}？
            <br />
            {{ $t("global.参考") }}：{{
              $t("global.这个作品之所以能够达到")
            }}/{{ $t("global.超越预期的目标") }}，是因为流程中我们
            在···（流程管理、工具方法、执行过程）方面做了···
          </p>
          <el-input
            type="textarea"
            v-model="ruleForm.processMethod"
            :placeholder="$t('global.请填写中文版')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="enProcessMethod" class="bottom5">
          <el-input
            type="textarea"
            v-model="ruleForm.enProcessMethod"
            :placeholder="$t('global.请填写英文版')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="processMethodIsOpen">
          <el-checkbox-group v-model="ruleForm.processMethodIsOpen">
            <el-checkbox
              :label="$t('global.不公开')"
              name="processMethodIsOpen"
            ></el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item :label="$t('global.作品投入')" prop="projectInput">
          <p class="intro">
            {{ $t("global.该作品从设计到交付，花费了 多少时间？参考：") }}：
            <br />
            {{
              $t(
                "global.该作品从立项到设计交付，花费了多少时间？总共 有多少投入？"
              )
            }}？
          </p>
          <el-input
            type="textarea"
            v-model="ruleForm.projectInput"
            :placeholder="$t('global.请填写中文版')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="enProjectInput" class="bottom5">
          <el-input
            type="textarea"
            v-model="ruleForm.enProjectInput"
            :placeholder="$t('global.请填写英文版')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="projectInputIsOpen">
          <el-checkbox-group v-model="ruleForm.projectInputIsOpen">
            <el-checkbox
              :label="$t('global.不公开')"
              name="projectInputIsOpen"
            ></el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item :label="$t('global.达成情况')" prop="situation">
          <p class="intro">
            {{ $t("global.该作品的目标是什么，结果和预期是否一致？参考：") }}：
            <br />
            1.{{
              $t(
                "global.做这个作品的初心是为了···，最终的结果 在···方面取得了出乎预料的表现"
              )
            }}
            <br />
            2.{{
              $t(
                "global.做这个作品是为了遵循公司的···战略，作品最终对于这个 战略 的推动意义是···"
              )
            }}
          </p>
          <el-input
            type="textarea"
            v-model="ruleForm.situation"
            :placeholder="$t('global.请填写中文版')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="enSituation" class="bottom5">
          <el-input
            type="textarea"
            v-model="ruleForm.enSituation"
            :placeholder="$t('global.请填写英文版')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="situationIsOpen">
          <el-checkbox-group v-model="ruleForm.situationIsOpen">
            <el-checkbox
              :label="$t('global.不公开')"
              name="situationIsOpen"
            ></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </div>
      <div v-if="matchId == 1031">
        <div class="pointBox1">
          <div class="scene">
            <span class="xing">*</span>{{ $t("video.请选择场景")
            }}<span class="title1">{{ $t("global.可多选") }}</span>
          </div>
          <div class="box1">
            <span
              v-for="(item, i) in pointList"
              :key="i"
              :class="{ active: positionList.id == item.id }"
              @click="selectPoint(item.id)"
              >{{ language == 'zh' ? item.name : item.enName
              }}<i v-if="getNumber(item.id)"
                >({{ getNumber(item.id) }})</i
              ></span
            >
          </div>
          <div v-if="positionList && positionList.childPoint">
            <div class="scene">
              <span class="xing">*</span>{{ $t("global.请选择")
              }}<span class="title2">{{ language == 'zh' ? positionList.name : positionList.enName }}</span
              >{{ $t("video.的点位")
              }}<span class="title1">{{ $t("global.可多选") }}</span>
            </div>
            <div class="box2">
              <span
                v-for="(item, i) in positionList.childPoint"
                :key="i"
                :class="{ active: getActive(item.id) }"
                @click="selectPosition(item)"
                >{{ language == 'zh' ? item.name : item.enName }}</span
              >
            </div>
          </div>
          <div class="line"></div>
          <div class="scene">
            <span class="title1"
              >{{ $t("video.已选择") }} <i>{{ this.zipList.length }}</i>
              {{ $t("video.个点位") }}</span
            >
          </div>
          <div class="box3 clearfix">
            <div
              :class="[language == 'zh' ? 'zipBox':'zipBox zipBox1']"
              v-for="(item, i) in zipList"
              :key="i"
              @mouseenter="zipHover = i"
              @mouseleave="zipHover = null"
            >
              <div class="name">{{ language == 'zh' ? item.name : item.enName }}_{{ language == 'zh' ? item.childName : item.childEnName }}</div>
              <img
                v-if="zipHover == i"
                class="img2"
                @click="deteleZip(item.childId)"
                src="/static/match/images/x_btn@2x.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="yunyi">
          <div class="inputBox">
          <div class="titleInput">
            {{ $t("works.上传附件")
            }}<span>{{
              $t("works.可上传多个附件(压缩包、PDF等)，每个附件大小不超过100M")
            }}</span>
          </div>
          <div class="enclosure clearfix">
            <div
              class="sureList"
              v-for="(item, i) in ruleForm.attachments"
              :key="i"
            >
              {{ item.name }}
              <img
                src="/static/uploadvideo/img_x_del_icon@2x.png"
                alt=""
                @click="deleteSure(i)"
              />
            </div>
            <div class="uploadSure" @click="upload">{{ $t("works.上传") }}</div>
          </div>
        </div>
        </div>
      </div>
      <div class="yunyi" v-if="matchId == 1032 || matchId == 1035">
          <div class="inputBox">
          <div class="titleInput">
            {{ $t("works.上传附件")
            }}<span>{{
              $t("works.可上传多个附件(压缩包、PDF等)，每个附件大小不超过100M")
            }}</span>
          </div>
          <div class="enclosure clearfix">
            <div
              class="sureList"
              v-for="(item, i) in ruleForm.attachments"
              :key="i"
            >
              {{ item.name }}
              <img
                src="/static/uploadvideo/img_x_del_icon@2x.png"
                alt=""
                @click="deleteSure(i)"
              />
            </div>
            <div class="uploadSure" @click="upload">{{ $t("works.上传") }}</div>
          </div>
        </div>
        </div>
      <div class="project_address" v-if="matchId == 1010">
        <p class="title">
          Realibox项目地址
          <span
            >如提交作品为3D交互类（realibox项目）作品，请填入realibox分享链接地址，如其他类作品可不填写。</span
          >
        </p>
        <input
          class="address_input"
          type="text"
          v-model="realiBox"
          placeholder="如：http://studio.realibox.com/public/3424c8592450b6f5e14640cb30a8152792cc1784"
        />
      </div>
      <div class="yunyi" v-if="matchId == 1027">
        <div class="inputBox">
          <div class="titleInput">{{ $t("works.指导老师") }}</div>
          <input
            class="address_input1"
            :placeholder="$t('works.选填，请输入指导老师姓名')"
            v-model="ruleForm.adviser"
          />
        </div>
        <div class="inputBox">
          <div class="titleInput">{{ $t("works.指导老师手机号") }}</div>
          <input
            class="address_input1"
            :placeholder="$t('works.选填，请输入指导老师手机号')"
            v-model="ruleForm.adviserMobile"
          />
        </div>
        <div class="inputBox">
          <div class="titleInput">
            {{ $t("works.在线互动demo URL地址")
            }}<span>{{ $t("works.如Realibox等") }}</span>
          </div>
          <input
            class="address_input2"
            :placeholder="$t('works.选填，在线互动demo URL地址')"
            v-model="ruleForm.demoAddress"
          />
        </div>
        <div class="inputBox">
          <div class="titleInput">
            {{ $t("works.上传附件")
            }}<span>{{
              $t("works.works.可上传多个附件(压缩包、PDF等)，每个附件大小不超过100M")
            }}</span>
          </div>
          <div class="enclosure clearfix">
            <div
              class="sureList"
              v-for="(item, i) in ruleForm.attachments"
              :key="i"
            >
              {{ item.name }}
              <img
                src="/static/uploadvideo/img_x_del_icon@2x.png"
                alt=""
                @click="deleteSure(i)"
              />
            </div>
            <div class="uploadSure" @click="upload">{{ $t("works.上传") }}</div>
          </div>
        </div>
      </div>
      <el-form-item label prop>
        <el-checkbox-group v-model="isAgree" class="agreeRule">
          <el-checkbox name="agree"></el-checkbox>
        </el-checkbox-group>
        <a class="rule" v-if="matchId == 1031" href="javascript:;" @click="getRule()">{{
          $t("video.我已了解并同意本次活动应征条款")
        }}</a>
        <a class="rule" v-else href="javascript:;" @click="getRule()">{{
          $t("global.我已同意本次赛事参赛条款及细则")
        }}</a>
      </el-form-item>
    </el-form>
    <div class="hasSubmit" v-if="hasSubmit">
      <img src="/static/icon_submit_done.png" alt />
      <h4>{{ $t("global.恭喜你") }}，{{ $t("global.提交成功") }}！</h4>
      <div v-if="matchId == 1035">
        <p v-html="$t('works.您已成功提交参赛作品，该作品将会在作品征集截止（2022年9月30日）后同步至竞赛主办方官网“澜景· 未来媒体学院奖”（x）。',{count: 'fmaa.cc'})"></p>
        <p v-html="$t('works.学院奖官网登录账号为您的注册邮箱，默认密码将在作品征集截止后发送至您的邮箱，请注意查收。感谢参与！',{count: 'fmaa.cc'})"></p>
      </div>
      <p v-else>{{ $t("video.后续作品入围后我们将通过邮件和短信告知，敬请留意") }}</p>
    </div>
    <input
      type="file"
      style="display: none"
      class="upInputSure"
      @change="upVideo"
    />
    <div class="popBox" v-if="isShowPop">
      <div class="confirmBox">
        <div class="titleBox">
          <span>{{$t('video.确认信息')}}</span>{{$t('video.请仔细核对所要提交的信息是否正确')}}<img @click="isShowPop=false" src="/static/close_btn@2x.png" alt="">
        </div>
        <div class="formBox" v-if="videoInfo">
          <div class="everyTitle clearfix"><span class="title">{{$t('global.真实姓名')}}</span><span class="info">{{peopleMessage.name}}</span></div>
          <div class="everyTitle clearfix"><span class="title">{{$t('global.手机号')}}</span><span class="info">{{peopleMessage.phone}}</span></div>
          <div class="everyTitle clearfix"><span class="title">{{$t('global.邮箱')}}</span><span class="info">{{peopleMessage.email}}</span></div>
          <div class="everyTitle clearfix"><span class="title">{{$t('global.国籍')}}</span><span class="info">{{peopleMessage.nationality}}</span></div>
          <div class="everyTitle clearfix"><span class="title">{{$t('global.个人介绍')}}</span><span class="info">{{peopleMessage.introduce}}</span></div>
          <div class="everyTitle clearfix"><span class="title">{{$t('global.个人介绍')}}({{$t('global.英文')}})</span><span class="info">{{peopleMessage.enIntroduce}}</span></div>
          <div class="everyTitle clearfix"><span class="title">{{$t('global.状态')}}</span><span class="info">{{peopleMessage.isGraduation==1?$t('global.已毕业'):$t('global.在读学生')}}</span></div>
          <div class="everyTitle clearfix"><span class="title">{{$t('global.毕业/所在院校')}}</span><span class="info">{{peopleMessage.school}}</span></div>
          <div class="everyTitle clearfix"><span class="title">{{$t('global.职业')}}</span><span class="info">{{peopleMessage.career}}</span></div>
          <div class="everyTitle clearfix"><span class="title">{{$t("global.视频标题")}}</span><span class="info">{{videoInfo.title}}</span></div>
          <div class="everyTitle clearfix"><span class="title">{{$t("global.视频标题")}}({{$t("global.英文")}})</span><span class="info">{{videoInfo.enTitle}}</span></div>
          <div class="everyTitle clearfix"><span class="title">{{$t('video.视频类型')}}</span><span class="info">{{videoInfo.isOriginal==1?$t("global.原创"):$t("global.非原创")}}</span></div>
          <div class="everyTitle clearfix"><span class="title">{{$t('video.视频是否公开')}}</span><span class="info">{{videoInfo.isPub==1?$t("global.不公开"):$t("video.公开")}}</span></div>
          <div class="everyTitle clearfix"><span class="title">{{$t('video.视频下载')}}</span><span class="info">{{videoInfo.allowDownload == 1?$t("global.开放"):$t("global.不开放")}}</span></div>
          <div class="everyTitle clearfix"><span class="title">{{$t('global.参赛方式')}}</span><span class="info">{{ruleForm.entryMode==1?$t("global.个人"):$t("global.团队")}}</span></div>
          <div class="everyTitle clearfix"><span class="title">{{$t('video.场景及点位')}}</span><span class="info"><i v-for="(item,i) in zipList" :key='i'>{{ item.name }}_{{ item.childName }}</i></span></div>
          <div class="everyTitle clearfix"><span class="title">{{$t("works.上传附件")}}</span><span class="info"><i v-for="(item, i) in ruleForm.attachments" :key="i">{{item.name}}</i></span></div>
        </div>
        <div class="bouBox">
          <span class="closeBox" @click="isShowPop=false">{{$t('global.返回')}}</span><span class="confirm" @click="confirm">{{$t('global.提交')}}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import * as qiniu from "qiniu-js";
export default {
  data() {
    return {
      contestName: "",
      industryIds: [],
      otherCategoryIds: [],
      categoryList: [],
      realiBox: null,
      ruleForm: {
        categoryId: undefined,
        entryMode: 1,
        teamName: "",
        userValue: "",
        enUserValue: "",
        userValueIsOpen: false,
        businessPerformance: "",
        enBusinessPerformance: "",
        businessPerformanceIsOpen: false,
        socialImpact: "",
        enSocialImpact: "",
        socialImpactIsOpen: false,
        team: "",
        enTeam: "",
        teamIsOpen: false,
        processMethod: "",
        enProcessMethod: "",
        processMethodIsOpen: false,
        projectInput: "",
        enProjectInput: "",
        projectInputIsOpen: false,
        situation: "",
        enSituation: "",
        situationIsOpen: "",
        estimateCost: null,
        adviser: "",
        adviserMobile: "",
        demoAddress: "",
        attachments: []
      },
      rules: {
        categoryId: [
          {
            required: true,
            message: this.$t("global.请选择参赛类别"),
            trigger: "blur"
          }
        ],
        entryMode: [
          {
            required: true,
            message: this.$t("global.请选择参赛方式"),
            trigger: "blur"
          }
        ],
        estimateCost: [
          {
            required: true,
            message: this.$t("works.请选择预估作品落地成本"),
            trigger: "blur"
          }
        ],
        teamName: [
          {
            required: true,
            message: this.$t("global.请填写团队名称"),
            trigger: "blur"
          }
        ],
        userValue: [
          {
            required: true,
            message: this.$t("global.请填写用户价值"),
            trigger: "blur"
          }
        ],
        enUserValue: [
          {
            required: true,
            message: this.$t("global.请填写英文用户价值"),
            trigger: "blur"
          }
        ],
        userValueIsOpen: [],
        businessPerformance: [
          {
            required: true,
            message: this.$t("global.请填写商业表现"),
            trigger: "blur"
          }
        ],
        enBusinessPerformance: [
          {
            required: true,
            message: this.$t("global.请填写英文商业表现"),
            trigger: "blur"
          }
        ],
        businessPerformanceIsOpen: [],
        socialImpact: [
          {
            required: true,
            message: this.$t("global.请填写社会影响"),
            trigger: "blur"
          }
        ],
        enSocialImpact: [
          {
            required: true,
            message: this.$t("global.请填写英文社会影响"),
            trigger: "blur"
          }
        ],
        socialImpactIsOpen: [],
        team: [
          {
            required: true,
            message: this.$t("global.请填写团队组织"),
            trigger: "blur"
          }
        ],
        enTeam: [
          {
            required: true,
            message: this.$t("global.请填写英文团队组织"),
            trigger: "blur"
          }
        ],
        teamIsOpen: [],
        processMethod: [
          {
            required: true,
            message: this.$t("global.请填写流程方法"),
            trigger: "blur"
          }
        ],
        enProcessMethod: [
          {
            required: true,
            message: this.$t("global.请填写英文流程方法"),
            trigger: "blur"
          }
        ],
        processMethodIsOpen: [],
        projectInput: [
          {
            required: true,
            message: this.$t("global.请填写项目投入"),
            trigger: "blur"
          }
        ],
        enProjectInput: [
          {
            required: true,
            message: this.$t("global.请填写英文项目投入"),
            trigger: "blur"
          }
        ],
        projectInputIsOpen: [],
        situation: [
          {
            required: true,
            message: this.$t("global.请填写达成情况"),
            trigger: "blur"
          }
        ],
        enSituation: [
          {
            required: true,
            message: this.$t("global.请填写英文达成情况"),
            trigger: "blur"
          }
        ],
        situationIsOpen: []
      },
      isAgree: false,
      pointList: [],
      positionList: {},
      zipList: [],
      zipHover: null,
      isConfirm: false,
      isShowPop: false,
      videoInfo: null
    };
  },
  props: ["matchId", "videoId", "hasSubmit", "pageId", "peopleMessage", "num"],
  mounted() {
    this.init();
  },
  watch: {
    industryIds() {
      if (this.matchId == 1032) {
        if (this.industryIds.length > 1) {
          this.$message(this.$t('video.首选投稿分类最多只能选1个'));
          this.industryIds.splice(this.industryIds.length - 1, 1);
        }
      } else if (this.matchId == 1038) {
        if (this.industryIds.length > 1) {
          this.$message(this.$t('video.参赛类别最多只能选1个'));
          this.industryIds.splice(this.industryIds.length - 1, 1);
        }
      } else {
        if (this.industryIds.length > Number(this.num)) {
          this.$message(`${this.$t("video.参赛类别最多只能选x个",{num:this.num})}`);
          this.industryIds.splice(this.industryIds.length - 1, 1);
        }
      }
    },
    otherCategoryIds() {
      if (this.otherCategoryIds.length > 1) {
        this.$message(this.$t('video.次选投稿分类最多只能选1个'));
        this.otherCategoryIds.splice(this.otherCategoryIds.length - 1, 1);
      }
    },
    matchId(value) {
      if (value) {
        this.getCategory();
      }
    }
  },
  computed: {
    language() {
      return this.$language();
    }
  },
  methods: {
    init() {
      this.contestName = this.$route.params.contestName;
      this.getCategory();
      const videoId = this.$route.query.videoId;
      if (videoId) {
        this.getInfo(videoId);
        this.detail(videoId);
      }
      this.getPoint();
    },
    getPoint() {
      this.$http.get("/api/nmatch/point").then(res => {
        this.pointList = res.data;
        this.positionList = res.data[0];
      });
    },
    selectPoint(id) {
      for (let i = 0; i < this.pointList.length; i++) {
        if (this.pointList[i].id == id) {
          this.positionList = this.pointList[i];
        }
      }
    },
    getActive(id) {
      if (this.zipList.length) {
        for (let i = 0; i < this.zipList.length; i++) {
          if (this.zipList[i].childId == id) {
            return true;
          }
        }
      }
      return false;
    },
    getNumber(id) {
      var number = 0;
      if (this.zipList.length) {
        for (let i = 0; i < this.zipList.length; i++) {
          if (this.zipList[i].id == id) {
            number += 1;
          }
        }
      }
      return number;
    },
    selectPosition(item) {
      if (this.zipList.length) {
        var ids = [];
        for (let i = 0; i < this.zipList.length; i++) {
          ids.push(this.zipList[i].childId);
        }
        var index = ids.indexOf(item.id);
        if (index == -1) {
          this.zipList.push({
            id: this.positionList.id,
            name: this.positionList.name,
            enName: this.positionList.enName,
            childId: item.id,
            childName: item.name,
            childEnName: item.enName
          });
        } else {
          this.zipList.splice(index, 1);
        }
      } else {
        this.zipList.push({
          id: this.positionList.id,
          name: this.positionList.name,
          enName: this.positionList.enName,
          childId: item.id,
          childName: item.name,
          childEnName: item.enName
        });
      }
    },
    deteleZip(id) {
      var ids = [];
      for (let i = 0; i < this.zipList.length; i++) {
        ids.push(this.zipList[i].childId);
      }
      var index = ids.indexOf(id);
      this.zipList.splice(index, 1);
    },
    upload() {
      document.querySelector(".upInputSure").value = "";
      document.querySelector(".upInputSure").click();
    },
    deleteSure(index) {
      this.ruleForm.attachments = this.ruleForm.attachments.filter(
        (item, i) => {
          return i != index;
        }
      );
    },
    upVideo(e) {
      var $this = this;
      var fileName = e.target.files[0].name;
      const type = e.target.files[0].type;
      // const list =
      //   "video/quicktime,video/x-flv,video/mpg,video/mpeg,video/x-msvideo,video/x-ms-wmv,video/x-ms-asf,	application/vnd.rn-realmedia,video/rmvb,video/mkv,video/mp4".split(
      //     ","
      //   );
      // if (!list.includes(type)) {
      //   this.$message.info(`${$this.$t("global.上传失败")},${this.$t(
      //     "global.请检查上传格式是否符合支持格式"
      //   )}`);
      //   return;
      // }
      if (e.target.files[0].size / 1024 / 1024 > 100) {
        this.$message.info(this.$t("works.文件不能大于100M"));
        return;
      }

      var observable;
      var subscription;
      var error = function(err) {
        $this.$message.error($this.$t("global.上传失败"));
      };

      var complete = function(res) {
        $this.ruleForm.attachments.push({
          name: e.target.files[0].name,
          key: res.key
        });
      };

      var next = function(response) {};
      var subObject = {
        next: next,
        error: error,
        complete: complete
      };

      var config = {
        useCdnDomain: true,
        disableStatisticsReport: false,
        retryCount: 3,
        region: null
      };
      var putExtra = {
        fname: fileName.split(".")[0],
        params: {},
        mimeType: null
      };
      this.$http.get("/api/common/upload/token/video").then(res => {
        this.token = res.data;
        observable = qiniu.upload(
          e.target.files[0],
          Date.parse(new Date()) + "_" + this.$jsonUtils.randomLetter(8),
          this.token,
          putExtra,
          config
        );
        subscription = observable.subscribe(subObject);
      });
    },
    detail(id) {
      this.$http
        .get("/api/match/video/getMatchVideo", {
          params: { videoId: id, matchUrl: this.$route.params.contestName }
        })
        .then(res => {
          this.ruleForm.entryMode = res.data.entryMode;
          this.ruleForm.estimateCost = res.data.estimateCost;
          this.ruleForm.teamName = res.data.teamName;
          if (res.data.pointData) {
            this.zipList = JSON.parse(res.data.pointData);
          }
          this.videoInfo = res.data.videoDetailResponse;
        });
    },
    isSelectOne(item, list) {
      let index = list.indexOf(item);
      if (index != -1) {
        return true;
      } else {
        return false;
      }
    },
    isSelectOne1(item, list) {
      let index = list.indexOf(item);
      if (index != -1) {
        return true;
      } else {
        return false;
      }
    },
    isSelectOne2(item, list) {
      let index = list.indexOf(item);
      if (index != -1) {
        return true;
      } else {
        return false;
      }
    },
    changeIndustryIds(id) {
      if (this.matchId == 1032) {
        let index = this.industryIds.indexOf(id);
        let index1 = this.otherCategoryIds.indexOf(id);
        if (index == -1 && index1 == -1) {
          this.industryIds.push(id);
        } else if (index1 == -1){
          this.industryIds.splice(index, 1);
        }
      } else {
        let index = this.industryIds.indexOf(id);
        if (index == -1) {
          this.industryIds.push(id);
        } else {
          this.industryIds.splice(index, 1);
        }
      }
    },
    changeIndustryIds1(id) {
      let index = this.industryIds.indexOf(id);
      let index1 = this.otherCategoryIds.indexOf(id);
      if (index == -1 && index1 == -1) {
        this.otherCategoryIds.push(id);
      } else if (index == -1){
        this.otherCategoryIds.splice(index, 1);
      }
    },
    getInfo(videoId) {
      const $this = this;
      const url = `/api/match/video/getMatchInformation`;
      const params = {
        videoId: videoId,
        matchUrl: this.$route.params.contestName
      };
      this.$http.get(url, { params }).then(res => {
        if (res.code === "OK" && res.data) {
          Object.keys(this.ruleForm).forEach(item => {
            if (/IsOpen$/.test(item)) {
              $this.ruleForm[item] = !res.data[item];
            } else {
              if (res.data[item]) {
                $this.ruleForm[item] = res.data[item];
              }
            }
          });
          if (this.ruleForm.attachments && this.ruleForm.attachments.length) {
            this.ruleForm.attachments = JSON.parse(this.ruleForm.attachments);
          }
          if (res.data.categoryId && res.data.categoryId.length) {
            this.industryIds = res.data.categoryId.split(",");
          }
          if (res.data.otherCategoryId && res.data.otherCategoryId.length) {
            this.otherCategoryIds = res.data.otherCategoryId.split(",");
          }
        }
      });
    },
    getCategory() {
      if (this.matchId) {
        const url = `/api/match/category/list/match`;
        this.$http.get(url, { params: { matchId: this.matchId } }).then(res => {
          this.categoryList = res.data || [];
          // this.industryIds = res.data;
        });
      }
    },
    getRule() {
      var name = "";
      if (this.matchId == 1031) {
        name = this.$t("video.应征条款");
      } else {
        name = this.$t("global.参赛条款及细则");
      }
      this.$http
        .get("/api/common/page", {
          params: {
            id: this.pageId
          }
        })
        .then(res => {
          this.$alert(res.data.body, name, {
            dangerouslyUseHTMLString: true,
            customClass: "alertMessage",
            showConfirmButton: false
          });
        });
    },
    submit() {
      if (this.isAgree) {
        if (localStorage.getItem("attachments")) {
          this.ruleForm.attachments = localStorage.getItem("attachments");
        } else {
          this.ruleForm.attachments = [];
        }
        console.log(this.ruleForm.attachments)
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            const params = {
              videoId: this.videoId,
              matchId: this.matchId,
              userId: this.$store.state.peopleMessage.userId
            };

            Object.keys(this.ruleForm).forEach(item => {
              if (/IsOpen$/.test(item)) {
                params[item] = !this.ruleForm[item];
              } else {
                params[item] = this.ruleForm[item];
              }
            });
            const url = "/api/match/video/updateVideoToSuccessfulMatch";
            this.$http.post(url, params).then(res => {
              if (res.code === "OK") {
                this.$emit("callback");
                localStorage.setItem("attachments", null)
              }
            });
          }
        });
      } else {
        if (this.matchId == 1031) {
          this.$message.info(this.$t("video.请先同意本次活动应征条款"));
        } else {
          this.$message.info(this.$t("global.请先同意本次赛事参赛条款及细则"));
        }
      }
    },
    confirm() {
      this.isConfirm = true;
      this.isShowPop = false;
      this.submitNormal();
    },
    submitNormal() {
      if (
        this.categoryList &&
        this.categoryList.length &&
        this.matchId !== 1031
      ) {
        if (!this.industryIds.length) {
          this.$message(this.$t("global.请选择参赛类别"));
          return;
        }
      }
      if (this.matchId == 1031) {
        if (!this.zipList.length) {
          this.$message(this.$t("video.请选择场景以及点位"));
          return;
        }
      }
      if (this.isAgree) {
        if (this.matchId == 1031 && !this.isConfirm) {
          if (sessionStorage.getItem("changeUserInfo")) {
            var userInfo = JSON.parse(sessionStorage.getItem("changeUserInfo"));
            this.peopleMessage = userInfo;
          }
          if (sessionStorage.getItem("videoInfo")) {
            var videoInfo = JSON.parse(sessionStorage.getItem("videoInfo"));
            this.videoInfo = videoInfo;
          }
          this.isShowPop = true;
          return;
        }
        var attachments = null;
        if (localStorage.getItem("attachments")) {
          attachments = localStorage.getItem("attachments");
        } else {
          attachments = [];
        }
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            const params = {
              videoId: this.videoId,
              matchId: this.matchId,
              userId: this.$store.state.peopleMessage.userId,
              categoryIds: this.industryIds.toString(),
              otherCategoryIds: this.otherCategoryIds.toString(),
              entryMode: this.ruleForm.entryMode,
              estimateCost: this.ruleForm.estimateCost,
              teamName: this.ruleForm.teamName,
              realiBox: this.realiBox,
              isUpdate: true,
              adviser: this.ruleForm.adviser,
              adviserMobile: this.ruleForm.adviserMobile,
              demoAddress: this.ruleForm.demoAddress,
              attachments: attachments,
              pointData: JSON.stringify(this.zipList)
            };
            const url = "/api/match/video/updateVideoToSuccessfulMatch";
            this.$http.post(url, params).then(res => {
              if (res.code === "OK") {
                this.$emit("callback");
                localStorage.setItem("attachments", null)
              }
            });
          }
        });
      } else {
        if (this.matchId == 1031) {
          this.$message.info(this.$t("video.请先同意本次活动应征条款"));
        } else {
          this.$message.info(this.$t("global.请先同意本次赛事参赛条款及细则"));
        }
      }
    }
  }
};
</script>
<style>
.ruleForm .el-form-item__label {
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  float: none;
}
.ruleForm .el-radio-group {
  display: block;
}
.ruleForm .el-form-item__content {
  margin-top: 12px;
}
</style>
<style lang="stylus" scoped>
.contest-step3 {
  padding: 0 80px 40px;

  .hasSubmit {
    text-align: center;

    h4 {
      color: #333333;
      height: 25px;
      font-size: 18px;
      font-weight: 600;
      line-height: 25px;
      padding: 20px 0;
    }

    p {
      font-size: 14px;
      color: #999999;
      line-height: 20px;
    }
    div{
      p{
        font-size: 14px;
        font-weight: 500;
        color: #666666;
        line-height: 22px;
        margin-bottom: 22px;
        a{
          color: #2026CC;
        }
      }
    }
  }

  a, p {
    font-weight: 400;
  }

  .agreeRule {
    display: inline-block;
  }

  .el-form-item {
    font-size: 12px;
    color: #333;
    font-weight: 600;
  }

  .el-input {
    width: 500px;
  }

  .notice {
    height: 17px;
    font-size: 12px;
    font-weight: 400;
    color: #999;
    line-height: 17px;
    padding: 10px 10px 30px;
  }

  .bottom5 {
    margin-bottom: 5px;
  }

  .project_address {
    margin: 30px 0;

    .title {
      font-size: 16px;
      font-weight: 600;
      color: #333333;

      span {
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        margin-left: 5px;
      }
    }

    .address_input {
      width: 730px;
      height: 40px;
      line-height: 40px;
      margin-top: 13px;
      border: 1px solid #E0E0E0;
      padding-left: 15px;
    }
  }

  .yunyi {
    .inputBox {
      margin-bottom: 30px;

      .titleInput {
        height: 22px;
        font-size: 16px;
        font-weight: 600;
        color: #333333;
        line-height: 22px;
        margin-bottom: 12px;

        span {
          font-size: 14px;
          font-weight: 400;
          color: #B8B8B8;
          margin-left: 10px;
        }
      }

      .address_input1 {
        width: 285px;
        height: 40px;
        line-height: 40px;
        border: 1px solid #E0E0E0;
        padding-left: 15px;
      }

      .address_input2 {
        width: 730px;
        height: 40px;
        line-height: 40px;
        border: 1px solid #E0E0E0;
        padding-left: 15px;
      }

      .enclosure {
        .sureList {
          padding: 0 10px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          border: 1px solid #999999;
          font-size: 14px;
          font-weight: 500;
          color: #B8B8B8;
          cursor: pointer;
          float: left;
          margin-right: 10px;
          margin-bottom: 10px;
          position: relative;

          img {
            position: absolute;
            width: 25px;
            height: 25px;
            right: -8px;
            top: -8px;
            cursor: pointer;
            display: none;
          }

          &:hover {
            img {
              display: block;
            }
          }
        }

        .uploadSure {
          width: 144px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          border: 1px solid #999999;
          font-size: 16px;
          font-weight: 500;
          color: #333333;
          cursor: pointer;
          float: left;
        }
      }
    }
  }
}

.contain {
  padding: 10px 0;

  .left {
    .font {
      font-size: 16px;
      font-weight: 600;
      color: #333;
      display: inline-block;
    }
    .font1 {
      font-size: 16px;
      font-weight: 600;
      color: #333;
      display: inline-block;
      padding-left: 10px;
    }
    span {
      font-size: 14px;
      font-weight: 400;
      color: #b8b8b8;
      margin-left: 10px;
    }

    .font:before {
      content: '*';
      color: #F56C6C;
      margin-right: 4px;
    }
  }

  .right {
    margin-top: 12px;

    .moretitle {
      overflow: hidden;
    }

    .moretitle span {
      display: inline-block;
      float: left;
      font-size: 14px;
      color: #999;
      height: 32px;
      cursor: pointer;
      line-height: 32px;
      padding: 0 12px;
      border-radius: 16px;
      cursor: pointer;
      margin: 0 10px 10px 0;
      border: 1px solid rgba(204, 208, 215, 1);
      box-sizing: border-box;
    }

    .moretitle .active {
      color: #0079FF;
      height: 32px;
      border: 1px solid #0079FF;
      box-sizing: border-box;
    }
    .moretitle .active1 {
      cursor: context-menu;
      border: 1px solid #eee;
      color: #ccc;
    }

    span {
      color: #999;
      font-size: 12px;
      display: block;
      line-height: 25px;
      margin-bottom: 10px;

      b {
        color: #D0021B;
      }
    }

    &.female {
      span {
        line-height: 18px;

        b {
          color: #333;
        }
      }
    }
  }
}
</style>

<style lang="stylus">
.el-message-box {
  width: 730px !important;

  li, dl, dt, dd {
    list-style: initial !important;
  }
}

.alertMessage {
  height: calc(100vh - 300px);

  .el-message-box__content {
    height: calc(100% - 100px);
    overflow-y: scroll;
    padding: 28px 40px;
  }
}

.contest-step3 {
  .el-form-item__content {
    .el-textarea {
      // height:100px;
      textarea {
        height: 120px;
      }
    }

    .el-checkbox {
      min-width: auto;
      margin-right: 10px;
    }
  }

  .notice2 {
    margin-top: 50px;
  }

  .ruleForm .intro {
    margin: 10px 0;
    color: #999;
    line-height: 1.5em;
  }
}

p.MsoNormal {
  min-height: 24px;
}

.pointBox1 {

  .scene {
    height: 27px;
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    line-height: 27px;

    .title1 {
      font-size: 13px;
      font-weight: 400;
      color: #999999;
      margin-left: 12px;

      i {
        color: #333;
        font-weight: 600;
      }
    }

    .title2 {
      font-size: 16px;
      font-weight: 600;
      color: #2026CC;
      margin: 0 4px;
    }
    .xing{
      color: #F56C6C;
      margin-right: 4px;
    }
  }

  .box1 {
    margin: 28px 0 40px 0;

    span {
      display: inline-block;
      padding: 0 30px;
      height: 30px;
      line-height: 30px;
      background: #F5F5F5;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      margin-right: 12px;
      margin-bottom: 12px;
      cursor: pointer;
    }

    .active {
      background: #2026CC;
      font-weight: 600;
      color: #fff;
    }
  }

  .box2 {
    margin: 28px 0 40px 0;

    span {
      display: inline-block;
      padding: 0 20px;
      height: 28px;
      line-height: 28px;
      border: 1px solid rgba(184, 184, 184, 0.85);
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      margin-right: 12px;
      margin-bottom: 12px;
      cursor: pointer;
    }

    .active {
      border: 1px solid rgba(32, 38, 204, 0.85);
      font-weight: 600;
      color: #2026CC;
    }
  }
  .line {
      border: 1px solid #EBEBEB;
      margin-bottom: 47px;
    }

    .box3 {
      margin: 28px 0;

      .zipBox {
        float: left;
        margin-right: 16px;
        margin-bottom: 28px;
        text-align: center;
        height: 40px;
        padding: 10px;
        background: rgba(32, 38, 204, 0.1);
        position: relative;
        .name {
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 20px;
          width: 120px;
          word-break: break-all;
        }
        img{
          width: 24px;
          height: 24px;
          position: absolute;
          top: -12px;
          right: -12px;
          cursor: pointer;
        }
      }
      .zipBox1{
        height: 80px;
      }
    }

    .upload {
      display: inline-block;
      padding: 0 16px;
      height: 36px;
      line-height: 36px;
      background: hsla(225, 84%, 57%, 0.1);
      font-size: 14px;
      font-weight: 600;
      color: #3664ED;
      cursor: pointer;

      img {
        width: 20px;
        height: 20px;
        margin-right: 4px;
        vertical-align: text-bottom;
      }
    }
}
.contest-step3{
  position: relative;
  .popBox{
      position: fixed;
      width: 100%;
      height: 100vh;
      left: 0;
      top: 0;
      background: rgba(0, 0, 0, 0.4);
      z-index: 999;
      .confirmBox{
        width: 730px;
        height: 588px;
        background: rgba(255, 255, 255, 1);
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        .titleBox{
          height: 60px;
          line-height: 60px;
          font-size: 13px;
          font-weight: 400;
          color: #999999;
          padding-left: 30px;
          border-bottom: 1px solid #E0E0E0;
          position: relative;
          span{
            font-size: 18px;
            font-weight: 600;
            color: #0A0A0A;
            margin-right: 12px;
          }
          img{
            position: absolute;
            right: 24px;
            top: 23px;
            width: 13px;
            height: 13px;
            cursor: pointer;
          }
        }
        .formBox{
          padding: 27px 30px 30px;
          height: 400px;
          overflow-y: auto;
          .everyTitle{
            margin-bottom: 16px;
            .title{
              font-size: 14px;
              font-weight: 600;
              color: #333333;
              float: left;
              width: 20%;
            }
            .info{
              font-size: 14px;
              font-weight: 400;
              color: #666666;
              float: left;
              width: 80%;
              i{
                margin-right: 20px;
              }
            }
          }
        }
        .bouBox{
          height: 70px;
          line-height: 70px;
          text-align: center;
          border-top: 1px solid #E0E0E0;
          .closeBox{
            display: inline-block;
            width: 144px;
            height: 40px;
            line-height: 40px;
            border: 1px solid #999999;
            font-size: 16px;
            font-weight: 500;
            color: #333333;
            box-sizing: border-box;
            vertical-align: middle;
            margin-right: 30px;
            cursor: pointer;
          }
          .confirm{
            display: inline-block;
            width: 144px;
            height: 40px;
            line-height: 40px;
            background: #2026CC;
            font-size: 16px;
            font-weight: 500;
            color: #FFFFFF;
            vertical-align: middle;
            cursor: pointer;
          }
        }
      }
 }
}
</style>



// WEBPACK FOOTER //
// src/pages/match/contestEnterStep/step3.vue